import React, { useState, useContext } from 'react'
import { Modal } from 'react-bootstrap'
import "./ModalNewIndicador.scss"
import { indicadoresNormasContext } from '../../IndicadoresNormas/IndicadoresNormas';
import { NormasContext } from '../../../context/NormasContext';
// chart
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function ModalNewIndicador(props) {

    const { user, idProyecto } = useContext(indicadoresNormasContext)
    const { fetchIndicadoresNormas } = useContext(NormasContext)

    const [newIndicador, setNewIndicador] = useState({
        nombre: "",
        descripcion: "",
        frecuencia: "",
        responsable: "",
        responsableSuplente: "",
        log: "",
        valorFuturo: ""
    })

    const [step, setStep] = useState(1)

    const [modalErr, setModalErr] = useState(null)
    const [errorMetrica, setErrorMetrica] = useState(null)
    const [errors, setErrors] = useState(null)

    const handleNext = () => {
        let errors = {}
        if(step === 1) {
            if(!newIndicador.nombre.trim()) {
                errors.nombre = "Escriba un nombre para el indicador."
            }
            if(!newIndicador.descripcion.trim()) {
                errors.descripcion = "Escriba un texto para la descripción."
            }
            if(!newIndicador.frecuencia.trim()) {
                errors.frecuencia = "Elija una frecuencia."
            }
            // responsable
            if(!newIndicador.responsable.trim()) {
                errors.responsable = "Escriba el mail."
            } else if (!/\S+@\S+\.\S+/.test(newIndicador.responsable)){
                errors.responsable = "El email no es válido."
            }
            // responsable suplente
            if(!newIndicador.responsableSuplente.trim()) {
                errors.responsableSuplente = "Escriba el mail."
            } else if (!/\S+@\S+\.\S+/.test(newIndicador.responsableSuplente)){
                errors.responsableSuplente = "El email no es válido."
            }
            if((Object.keys(errors).length === 0)){
                setErrors(null)
                setStep(step + 1)
            } else {
                setErrors(errors)
            }
        }

        if(step === 2){
            if(!newIndicador.log.trim()) {
                errors.log = "Escriba el valor real."
            }
            if(!newIndicador.valorFuturo.trim()) {
                errors.valorFuturo = "Escriba el valor de la meta esperada."
            }
            if((Object.keys(errors).length === 0)){
                setErrors(null)
                setStep(step + 1)
            } else {
                setErrors(errors)
            }
        }
        
    }

    const handleBack = () => setStep(step - 1)

    const handleClose = () => {
        props.onHide()
        setModalErr(null)
        setErrors(null)
        setNewIndicador({
            nombre: "",
            descripcion: "",
            frecuencia: "",
            responsable: "",
            responsableSuplente: "",
            log: "",
            valorFuturo: ""
        })
        setStep(1)
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewIndicador({
            ...newIndicador,
            [name]: value,
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        const bodyIndicador = {
            opcion: 2,
            idUnion: parseInt(idProyecto),
            user,
            nombre_indicador: newIndicador.nombre,
            detalles_metrica: newIndicador.descripcion,
            tipo_recordartorio: parseInt(newIndicador.frecuencia),
            responsable: newIndicador.responsable,
            empleadoSuplente: newIndicador.responsableSuplente,
            valorEsperado: parseInt(newIndicador.valorFuturo)
        }
        try {
            // NEW INDICADOR NORMAS ISO
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/dateIn/newIndicador`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(bodyIndicador)
            })
            const data = await res.json()
            const errorCode = data.error ?? data.status
            if(errorCode !== 0){
                setModalErr(data.codeError || data.errorDetalle)
            } else {
                const bodyMetrica = {
                    user,
                    fk_indicador: data?.objeto?.id_indicador,
                    dato_metrica: parseInt(newIndicador.log),
                    dato_futura_metrica: parseInt(newIndicador.valorFuturo)
                }
                try {
                    const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/dateIn/newMetrica`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(bodyMetrica)
                    })
                    const dataMetrica = await res.json()
                    const errorMetrica = dataMetrica.error ?? dataMetrica.status
                    if(errorMetrica !== 0){
                        setErrorMetrica(dataMetrica.codeError || dataMetrica.errorDetalle)
                    } else {
                        setNewIndicador(prev => ({
                            ...prev,
                            log: "",
                            valorFuturo: ""
                        }))
                    }
                } catch (error) {
                    setErrorMetrica("Error: Conexión con backend.")
                }
                handleClose()
                // actualizar indicadores
                fetchIndicadoresNormas({
                    user,
                    opcion: 2,
                    idVista: parseInt(idProyecto)
                })
            }
        } catch (error) {
            setModalErr("Error: Conexión con backend.")
        }
    }

    let arrMet = []
    let arrMetaEsperada = []
    let arrLabel = []
    const actualDay = new Date().toLocaleString("es-ES", {day: '2-digit', month: '2-digit', year: 'numeric'})
    const actualHour = new Date().toLocaleString("es-ES", {minute: '2-digit', hour: '2-digit', second: '2-digit'});
    arrMet.push(parseInt(newIndicador.log))
    arrMetaEsperada.push(parseInt(newIndicador.valorFuturo))
    arrLabel.push(actualDay)

    const data = {
        labels: arrLabel,
        datasets : [
            {
                label: "Valor real",
                data: arrMet,
                backgroundColor: 'rgba(158, 197, 254, 100)',
                borderWidth: 1
            },
            {
                label: "Meta esperada",
                data: arrMetaEsperada,
                backgroundColor: 'rgba(13, 110, 253, 100)',
                borderWidth: 1
            }
        ]
    }

    const options = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    }

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size='lg'
            backdrop="static"
            className='modal__indicadorNormas'
            dialogClassName={props.dialogClassName}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                    <h3 className='m-0'>Ingresa un indicador</h3>
                    <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className='form__indicadorNormas' onSubmit={handleSubmit}>
                        <div className='steps__container mb-4'>
                            {/* Paso 1 */}
                            <div className='steps d-flex flex-row align-items-center gap-2'>
                                <div className={`circleStep d-flex align-items-center justify-content-center rounded-circle ${step >= 1 ? "bg-blue-500 text-white" : "border border-2 border-primary"}`}>
                                    {step >= 1 ? <i className="bi bi-check2"></i> : <span className='text-blue-500'>1</span>}
                                </div>
                                <span className='text-nowrap'>Datos principales</span>
                                <div className={`lineStep border border-2 me-2 ${step >= 2 ? "border-primary" : "border-secondary-subtle"}`}></div>
                            </div>
                            {/* Paso 2 */}
                            <div className='steps d-flex flex-row align-items-center gap-2'>
                                <div className={`circleStep d-flex align-items-center justify-content-center rounded-circle ${step >= 2 ? "bg-blue-500 text-white" : "border border-2 border-primary"}`}>
                                    {step >= 2 ? <i className="bi bi-check2"></i> : <span className='text-blue-500'>2</span>}
                                </div>
                                <span className='text-nowrap'>Log</span>
                                <div className={`lineStep border border-2 me-2 ${step >= 3 ? "border-primary" : "border-secondary-subtle"}`}></div>
                            </div>
                            {/* Paso 3 */}
                            <div className='steps d-flex flex-row align-items-center gap-2'>
                                <div className={`circleStep d-flex align-items-center justify-content-center rounded-circle ${step >= 3 ? "bg-blue-500 text-white" : "border border-2 border-primary"}`}>
                                    {step >= 3 ? <i className="bi bi-check2"></i> : <span className='text-blue-500'>3</span>}
                                </div>
                            </div>
                        </div>
                        {step === 1 && (
                            <div className='d-flex flex-column'>
                                <div className='w-100 mb-2'>
                                    <label className='fw-medium text-blue-500 mb-1'>Nombre</label>
                                    <input
                                        type="text" 
                                        id="nombre" 
                                        name="nombre" 
                                        placeholder='Nombre'
                                        value={newIndicador.nombre}
                                        onChange={handleChange}
                                        autoFocus
                                        className={`w-100 form-control border no-outline focus-ring ${
                                            errors?.nombre ? "border-danger focus-ring-red" : "border-secondary-subtle focus-ring-blue"
                                        }`}
                                    />
                                    {errors?.nombre && <span className='form__indicadorNormas--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors?.nombre}</span>}
                                </div>
                                <div className='w-100 mb-2'>
                                    <label className='fw-medium text-blue-500 mb-1'>Descripción</label>
                                    <input
                                        type="text" 
                                        id="descripcion" 
                                        name="descripcion" 
                                        placeholder='Descripción'
                                        value={newIndicador.descripcion}
                                        onChange={handleChange}
                                        className={`w-100 form-control border no-outline focus-ring ${
                                            errors?.nombre ? "border-danger focus-ring-red" : "border-secondary-subtle focus-ring-blue"
                                        }`}
                                    />
                                    {errors?.descripcion && <span className='form__indicadorNormas--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors?.descripcion}</span>}
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-12 col-md-6'>
                                        <label className='fw-medium text-blue-500 mb-1'>Frecuencia</label>
                                        <select
                                            id="frecuencia"
                                            name="frecuencia"
                                            onChange={handleChange} 
                                            value={newIndicador.frecuencia}
                                            className={`w-100 form-select border no-outline focus-ring ${
                                                errors?.frecuencia ? "border-danger focus-ring-red" : "border-secondary-subtle focus-ring-blue"
                                            }`}
                                        >
                                            <option value="">Elija una opción</option>
                                            <option value="1">Semanal</option>
                                            <option value="2">Quincenal</option>
                                            <option value="3">Mensual</option>
                                            <option value="4">Trimestral</option>
                                        </select>
                                        {errors?.frecuencia && <span className='form__indicadorNormas--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors?.frecuencia}</span>}
                                    </div>
                                </div>
                                <div className='row mb-4'>
                                    <div className='col-12 col-md-6'>
                                        <label className='fw-medium text-blue-500 mb-1'>Responsable</label>
                                        <input
                                            type="email" 
                                            id="responsable" 
                                            name="responsable" 
                                            placeholder='usuario@correo.com.ar'
                                            value={newIndicador.responsable}
                                            onChange={handleChange}
                                            className={`w-100 form-control border no-outline focus-ring ${
                                                errors?.responsable ? "border-danger focus-ring-red" : "border-secondary-subtle focus-ring-blue"
                                            }`}
                                        />
                                        {errors?.responsable && <span className='form__indicadorNormas--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors?.responsable}</span>}
                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <label className='fw-medium text-blue-500 mb-1'>Responsable suplente</label>
                                        <input
                                            type="email" 
                                            id="responsableSuplente" 
                                            name="responsableSuplente" 
                                            placeholder='usuario@correo.com.ar'
                                            value={newIndicador.responsableSuplente}
                                            onChange={handleChange}
                                            className={`w-100 form-control border no-outline focus-ring ${
                                                errors?.responsableSuplente ? "border-danger focus-ring-red" : "border-secondary-subtle focus-ring-blue"
                                            }`}
                                        />
                                        {errors?.responsableSuplente && <span className='form__indicadorNormas--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors?.responsableSuplente}</span>}
                                    </div>
                                </div>
                                <div className='w-100 d-flex flex-row align-items-center justify-content-between'>
                                    <div className='invisible'></div>
                                    <button type="button" onClick={handleNext} className='btn btn-primary px-4 py-2 fw-medium rounded-pill cursor-pointer'>Siguiente</button>
                                </div>
                            </div>
                        )}
                        {step === 2 && (
                            <div className='flex flex-col items-center'>
                                <div className='row mb-4'>
                                    {/* Valor real */}
                                    <div className='col-12 col-md-6'>
                                        <label className='fw-medium text-blue-500 mb-1'>Ingresa el valor real</label>
                                        <input
                                            type="number" 
                                            id="log" 
                                            name="log" 
                                            placeholder='Valor real'
                                            value={newIndicador.log}
                                            onChange={handleChange}
                                            className={`w-100 input--arrows form-control border no-outline focus-ring ${
                                                errors?.log ? "border-danger focus-ring-red" : "border-secondary-subtle focus-ring-blue"
                                            }`}
                                        />
                                        {errors?.log && <span className='form__indicadorNormas--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors?.log}</span>}
                                    </div>
                                    {/* Valor meta */}
                                    <div className='col-12 col-md-6'>
                                        <label className='fw-medium text-blue-500 mb-1'>Ingresa la meta esperada</label>
                                        <input
                                            type="number" 
                                            id="valorFuturo" 
                                            name="valorFuturo" 
                                            placeholder='Meta esperada'
                                            value={newIndicador.valorFuturo}
                                            onChange={handleChange}
                                            className={`w-100 input--arrows form-control border no-outline focus-ring ${
                                                errors?.valorFuturo ? "border-danger focus-ring-red" : "border-secondary-subtle focus-ring-blue"
                                            }`}
                                        />
                                        {errors?.valorFuturo && <span className='form__indicadorNormas--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors?.valorFuturo}</span>}
                                    </div>
                                </div>
                                <div className='w-100 d-flex flex-row align-items-center justify-content-between'>
                                    <button type="button" onClick={handleBack} className='btn btn-outline-secondary px-4 py-2 fw-medium rounded-pill cursor-pointer'>Anterior</button>
                                    <button type="button" onClick={handleNext} className='btn btn-primary px-4 py-2 fw-medium rounded-pill cursor-pointer'>Siguiente</button>
                                </div>
                            </div>
                        )}
                        {step === 3 && (
                            <div className='d-flex flex-column'>
                                <div className='indicador__textos mb-3'>
                                    <h2 className='mb-2 text-blue-500'>{newIndicador.nombre}</h2>
                                    <p className='m-0 mb-1'><span className='text-secondary'>Descripción: </span>{newIndicador.descripcion}</p>
                                    <p className='m-0 mb-1'>
                                        <span className='text-secondary'>Frecuencia: </span>
                                        {newIndicador.frecuencia === "1" && "Semanal"}
                                        {newIndicador.frecuencia === "2" && "Quincenal"}
                                        {newIndicador.frecuencia === "3" && "Mensual"}
                                        {newIndicador.frecuencia === "4" && "Trimestral"}
                                    </p>
                                </div>
                                <div className='d-flex flex-row gap-4'>
                                    <div className='indicador__logs d-flex flex-column'>
                                        <div className='p-2 border border-1 border-light-subtle shadow-sm rounded-2'>
                                            <div className='d-flex flex-row align-items-center'>
                                                <i className="bi bi-person-circle me-2 text-primary"></i>
                                                <p className='m-0 text-truncate'>{newIndicador.responsable}</p>
                                            </div>
                                            <div className='d-flex flex-row align-items-center'>
                                                <i className='bi bi-bar-chart-fill me-2 text-primary'></i>
                                                <p className='m-0'>{newIndicador.log}</p>
                                            </div>
                                            <div className='d-flex flex-row align-items-center justify-content-between'>
                                                <div className='d-flex flex-row align-items-center'>
                                                    <i className="bi bi-calendar-event me-2 text-primary"></i>
                                                    <p className='m-0'>{actualDay}</p>
                                                </div>
                                                <div className='d-flex flex-row align-items-center'>
                                                    <i className="bi bi-clock me-2 text-primary"></i>
                                                    <p className='m-0'>{actualHour}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='indicador__grafica'>
                                        <div className=''>
                                            <Bar data={data} options={options} />
                                        </div>
                                    </div>
                                </div>
                                {modalErr !== null && <span className='form__indicadorNormas--error align-self-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                                {errorMetrica !== null && <span className='form__indicadorNormas--error align-self-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{errorMetrica}</span>}
                                <div className='w-100 d-flex flex-row align-items-center justify-content-between'>
                                    <button type="button" onClick={handleBack} className='btn btn-outline-secondary px-4 py-2 fw-medium rounded-pill cursor-pointer'>Anterior</button>
                                    <button type='submit' className='btn btn-primary rounded-pill px-3 fw-medium'>+ agregar indicador</button>
                                </div>
                            </div>
                        )}
                    </form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalNewIndicador